var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Grid, Typography } from "../../components";
import { COLOR } from "../../theme/constants";

var InvestmentCalculatorPlaceholder = function InvestmentCalculatorPlaceholder(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(Grid.Container, __assign({
    fluid: true,
    background: COLOR.lightGrey
  }, props), React.createElement(Grid.Container, null, React.createElement(Grid.Row, null, React.createElement(Grid.Col, {
    xs: 12,
    md: 7
  }, children), React.createElement(Grid.Col, {
    xs: 12,
    md: 5
  }, React.createElement(Grid.Box, {
    maxWidth: "270px",
    py: 5
  }, React.createElement(Typography, {
    color: "brandGreen",
    mb: 4
  }, "Kalkulator kredytu"), React.createElement(Typography, {
    variant: "h2",
    mb: 4,
    isUpperCase: true
  }, "Kredyt dopasowany do twoich potrzeb"), React.createElement(Typography, null, "Zapoznaj si\u0119 z powy\u017Csz\u0105 ofert\u0105, parametrami finansowania i wybierz produkt najbardziej dopasowany do Twojej potrzeby."), React.createElement(Typography, null, "Je\u015Bli masz dodatkowe pytania, pozostaw dane kontaktowe. Oddzwonimy."))))));
};

export default InvestmentCalculatorPlaceholder;